<div class="row py-2 px-4" *ngIf="loanListParameters && loanListParameters !== undefined">
  <div class="col-md-6 mt-2 col-xl-4 mt-xl-0">
    <button [ngClass]="'btn btn-block'" [class.btn-primary]="true" >
      Fechas <br>Ciclo de Cancelación
    </button>
  </div>
  <!--div class="col-md-6 mt-2 col-xl-4 mt-xl-0">
    <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.tabIndex === 1"
      [class.btn-outline-secondary]="contentLocation.tabIndex !== 1" (click)="switchTo(1)">
      Compañías<br>Incluidas
    </button>
  </div-->
</div>


<div class="p-4" >
  <div class="row">
    <div class="col-md-6">
      <mat-form-field>
        <input matInput [matDatepicker]="inicioDeCicloPicker" placeholder="Inicio De Ciclo:"
          (dateChange)="setRegistrationDate('starts', $event)" [value]="newLoanListDate.startDate">
        <mat-datepicker-toggle matSuffix [for]="inicioDeCicloPicker"></mat-datepicker-toggle>
        <mat-datepicker #inicioDeCicloPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="col-md-6">
      <mat-form-field>
        <input matInput [matDatepicker]="finDeCicloPicker" placeholder="Fin De Ciclo:"
          (dateChange)="setRegistrationDate('ends', $event)" [value]="newLoanListDate.endDate"
          [min]="newLoanListDate.startDate">
        <mat-datepicker-toggle matSuffix [for]="finDeCicloPicker"></mat-datepicker-toggle>
        <mat-datepicker #finDeCicloPicker></mat-datepicker>
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-md-4 offset-md-8 bottom-vertically">
      <button class="btn btn-block btn-primary" (click)="addDate()">Añadir</button>
    </div>
  </div>

  <div *ngIf="loanListDates && loanListDates.length > 0">
    <div class="my-5 row border-top">
      <mat-table #loanListDatesTable class="table" [dataSource]="loanListDates">

        <ng-container matColumnDef="InicioCiclo">
          <mat-header-cell *matHeaderCellDef>Inicio Del Ciclo</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.startDate | date: 'mediumDate'}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="FinCiclo">
          <mat-header-cell *matHeaderCellDef>Fin Del Ciclo</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.endDate ? (element.endDate | date: 'mediumDate') : ''}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="active">
          <mat-header-cell *matHeaderCellDef> Fecha Activa </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-checkbox [(ngModel)]="element.active" [disabled]="false">Fecha Activa</mat-checkbox>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="delete" class="center-text">
          <mat-header-cell *matHeaderCellDef><span>Eliminar</span></mat-header-cell>
          <mat-cell *matCellDef="let index = index">
            <button mat-icon-button color="warn" (click)="deleteLoanDate(index)">
              <mat-icon aria-label="Delete">delete_outline</mat-icon>
            </button>

          </mat-cell>
        </ng-container>

        <mat-header-row mat-header-row *matHeaderRowDef="displayedDatesColumns"></mat-header-row>
        <mat-row mat-row *matRowDef="let row; columns: displayedDatesColumns;"></mat-row>

      </mat-table>
    </div>

  </div>

</div>

<!--div class="p-4" *ngIf="contentLocation.tabIndex == 1">

  <div class="row">

    <div class="col-md-12">

      <mat-table #companiesTable class="table" [dataSource]="companies">


        <ng-container matColumnDef="companyID">
          <mat-header-cell mat-header-cell *matHeaderCellDef> ID </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element"> {{element.companyID}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="companyName">
          <mat-header-cell mat-header-cell *matHeaderCellDef> Nombre de la Compañía </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element"> {{element.companyName}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="taxationIdentificationNumber">
          <mat-header-cell mat-header-cell *matHeaderCellDef> Documento Legal </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element"> {{element.taxationIdentificationNumber}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="select">
          <mat-header-cell mat-header-cell *matHeaderCellDef>
            Incluir Compañía
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let row">
            <mat-checkbox id="{{row.companyID}}" (change)="changeCompany($event)"
              [checked]="selectionCompanies.isSelected(row)"></mat-checkbox>
          </mat-cell>
        </ng-container>

        <mat-header-row mat-header-row *matHeaderRowDef="displayedCompanyColumns"></mat-header-row>
        <mat-row mat-row *matRowDef="let row; columns: displayedCompanyColumns;"></mat-row>
      </mat-table>

    </div>

  </div>

</div-->